module.exports = __webpack_public_path__ + "static/media/people-grey-icon.5b3e3d14.svg";